// LiveDuration hook — ticks a running duration counter every second.
//
// Usage in HEEx:
//   Elapsed (count up):
//   <span phx-hook="LiveDuration" id="dur-123" data-started-at="2025-04-12T10:30:00Z">0s</span>
//
//   Countdown to a deadline (e.g. AI cost cap reset):
//   <span phx-hook="LiveDuration" id="reset-1" data-countdown-to="2026-07-01T00:00:00Z">…</span>
//
// `data-countdown-to` takes precedence over `data-started-at`. The countdown
// clamps at 0 and renders "0s" once the deadline passes.

function formatDuration(seconds) {
  if (seconds < 60) return `${seconds}s`
  if (seconds < 3600) {
    const m = Math.floor(seconds / 60)
    const s = seconds % 60
    return `${m}m ${s}s`
  }
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  return `${h}h ${m}m`
}

export default {
  mounted() {
    this.tick()
    this._interval = setInterval(() => this.tick(), 1000)
  },

  updated() {
    this.tick()
  },

  destroyed() {
    if (this._interval) clearInterval(this._interval)
  },

  tick() {
    const deadline = this.el.dataset.countdownTo
    if (deadline) {
      const target = new Date(deadline)
      const now = new Date()
      const remaining = Math.max(0, Math.floor((target - now) / 1000))
      this.el.textContent = formatDuration(remaining)
      return
    }

    const iso = this.el.dataset.startedAt
    if (!iso) return
    const started = new Date(iso)
    const now = new Date()
    const diff = Math.max(0, Math.floor((now - started) / 1000))
    this.el.textContent = formatDuration(diff)
  },
}
